import { ddeApi } from '@/service/ddeApi'
import { StandarizedGolfPlayer } from '@/views/DataAdmin/types'
import { entryListPlayerToStandarized } from '@/views/DataAdmin/utils'

import { createBaseTableStore } from '../table'
import { FetchApiArgs, FetchApiResponse } from '../table/table.types'
import {
  fetchTournamentsWithFeedCount,
  GolfTournamentWithFeedCount
} from '../tournaments/tournaments.utils'
import { makeWSDetails } from './tournament.utils'

export type EntryRow = {
  teamNo: number
  players: StandarizedGolfPlayer[]
  wsDetails: ReturnType<typeof makeWSDetails>
}

const fetchTournamentApiCallback = async (
  args: FetchApiArgs<number, string, string>
): Promise<FetchApiResponse<EntryRow, { tournament: GolfTournamentWithFeedCount | null }>> => {
  const { signal, additionalParams: tournamentId } = args

  const entryList = await ddeApi.endpoints.golf.tournaments.getEntryList(tournamentId, signal)
  const { data } = await ddeApi.endpoints.golf.tournaments.getTournament(tournamentId, signal)
  const dateFrom = data.startDate ? data.startDate : undefined
  const dateTo = data.endDate ? data.endDate : undefined

  const tournamentsWithFeedCount = await fetchTournamentsWithFeedCount({ dateFrom, dateTo, signal })

  const tournament = tournamentsWithFeedCount.find((t) => t.id === tournamentId) || null

  return {
    content: entryList.data.map((entry) => {
      return {
        teamNo: entry.teamNo,
        players: entry.players.map(entryListPlayerToStandarized),
        wsDetails: makeWSDetails(tournament, entry.teamNo)
      }
    }),
    totalElements: entryList.data.length,
    tournament
  }
}

export const useTournament = createBaseTableStore({
  storeName: 'Tournament',
  fetchApi: fetchTournamentApiCallback,
  customInitialState: {
    tournament: null
  }
})
